import {capitalize} from 'lodash/string';
import request from './base';
import {excludeObjNullValue} from 'utils/common';

/**
 * user endpoints
 */
export const fetchUsers = (q, page, perPage, sortOpts, extraParams) =>
  request.fetchList('/users', q, page, perPage, sortOpts, extraParams);

export const fetchUser = (userId) => request.fetchDetail(`/users/${userId}`);

export const createUser = (payload) =>
  request.postJSON(
    '/users',
    excludeObjNullValue({
      email: payload.email,
      username: payload.username,
      first_name: capitalize(payload.firstName),
      last_name: capitalize(payload.lastName),
      password: payload.password,
      role: payload.role,
      school_id: payload.schoolId,
      parent_id: payload.parentId,
    }),
  );

export const updateUser = (payload) =>
  request.putJSON(
    `/users/${payload.userId}`,
    excludeObjNullValue({
      username: payload.username,
      first_name: capitalize(payload.firstName),
      last_name: capitalize(payload.lastName),
      email: payload.email,
      password: payload.password,
    }),
  );

export const deleteUser = (userId) => request.deleteReq(`/users/${userId}`);

export const changeUserRole = (payload) =>
  request.putJSON(
    `/users/${payload.userId}/change-role`,
    excludeObjNullValue({
      role: payload.role,
    }),
  );

export const createReader = (payload) =>
  request.postJSON(
    '/users/readers',
    excludeObjNullValue({
      email: payload.email,
      username: payload.username,
      first_name: capitalize(payload.firstName),
      last_name: capitalize(payload.lastName),
      password: payload.password,
      level: payload.level,
    }),
  );

export const fetchParents = (q, page, perPage, sortOpts, extraParams = {}) =>
  request.fetchList('/users', q, page, perPage, sortOpts, {...extraParams, role: 'parent'});

export const associateParentAndReader = (payload) =>
  request.postJSON(
    '/users/parent-reader-association',
    excludeObjNullValue({
      parent_id: payload.parentId,
      reader_id: payload.readerId,
    }),
  );
